import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "header flex" }
const _hoisted_2 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "header flex" }
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ic = _resolveComponent("ic")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
  }, [
    _withDirectives(_createElementVNode("input", {
      placeholder: "Your Github account",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
      required: ""
    }, null, 512), [
      [_vModelText, _ctx.username]
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("button", null, "Summary", -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createTextVNode(" Organizations ")),
      _createElementVNode("div", {
        class: "add",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addItem(_ctx.organizations)))
      }, [
        _createVNode(_component_ic, { icon: "times" })
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.organizations, (org, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "input",
        key: index
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: 'Organisation#' + (index + 1),
          "onUpdate:modelValue": ($event: any) => ((_ctx.organizations[index]) = $event)
        }, null, 8, _hoisted_2), [
          [_vModelText, _ctx.organizations[index]]
        ]),
        _createElementVNode("div", {
          class: "delete",
          onClick: ($event: any) => (_ctx.removeItem(_ctx.organizations, index))
        }, [
          _createVNode(_component_ic, { icon: "times" })
        ], 8, _hoisted_3)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_4, [
      _cache[5] || (_cache[5] = _createTextVNode(" Repositories ")),
      _createElementVNode("div", {
        class: "add",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addItem(_ctx.repositories)))
      }, [
        _createVNode(_component_ic, { icon: "times" })
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.repositories, (repo, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "input",
        key: index
      }, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          placeholder: "owner/repository",
          "onUpdate:modelValue": ($event: any) => ((_ctx.repositories[index]) = $event)
        }, null, 8, _hoisted_5), [
          [_vModelText, _ctx.repositories[index]]
        ]),
        _createElementVNode("div", {
          class: "delete",
          onClick: ($event: any) => (_ctx.removeItem(_ctx.repositories, index))
        }, [
          _createVNode(_component_ic, { icon: "times" })
        ], 8, _hoisted_6)
      ]))
    }), 128))
  ], 32))
}